import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../useTable";
import { Mensaje } from "../mensajes2";
import { formatMoneda, formatoMonto, validaMonto, seleccionarCampo } from "../../util/varios";
import { Dimmer } from "../spinner";
//UI
import { Checkbox, Input, Radio, Textarea } from "../../ui/inputs/Input";
import { SuccessButton, DangerButton, InfoButton } from "../../ui/buttons/Button";
import axios from "axios";
import moment from "moment";
import { numeroaLetra } from "../../util/NumeroaLetra";

const headCells = [
	{
		id: "sec",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SEC.",
		textAlign: "center",
	},
	{
		id: "prog",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROG.",
		textAlign: "center",
	},
	{
		id: "spro",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SPRO.",
		textAlign: "center",
	},
	{
		id: "proy",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROY.",
		textAlign: "center",
	},
	{
		id: "act",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ACT.",
		textAlign: "center",
	},
	{
		id: "part",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PART.",
		textAlign: "center",
	},
	{
		id: "gen",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "GEN.",
		textAlign: "center",
	},
	{
		id: "esp",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ESP.",
		textAlign: "center",
	},
	{
		id: "sub",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SUB.",
		textAlign: "center",
	},
	{
		id: "ord",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ORD.",
		textAlign: "center",
	},
	{
		id: "concepto",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "CONCEPTO",
		textAlign: "center",
	},
	{
		id: "monto",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "MONTO DE LA OBRA Bs.",
		textAlign: "center",
	},
];

export default function CaratulaContrato(props) {
	const btnAcepta = useRef();
	const btnCancela = useRef();
	const btnImprimir = useRef();
	var op = require('../../modulos/datos')
	let token = localStorage.getItem('jwtToken');
	const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
	const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
	const [activate, setActivate] = useState(false);
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});

	const txtIdObra = useRef();
	const txtIdObraAsi = useRef();
	const txtIdProve = useRef();
	const txtDescripcionObra = useRef();
	const txtRazonSocial = useRef();
	const txtRif = useRef();
	const txtFechaApro = useRef();
	const txtMontoObra = useRef();
	const radioSi = useRef();
	const radioNo = useRef();
	const radioObra = useRef();
	const radioServicio = useRef();
	const txtNumContrato = useRef();
	const checkIva = useRef();
	const txtPorceFiel = useRef();
	const txtPorceAnti = useRef();
	const txtMontoFiel = useRef();
	const txtMontoAnti = useRef();
	const txtPlazoIni = useRef();
	const txtPlazoEjec = useRef();
	const txtGarantia = useRef();
	const txtManera = useRef();


	const [records, setRecords] = useState([]);
	const [filterFn, setFilterFn] = useState({
		fn: (items) => { return items },
	});

	const {
		TblContainer,
		TblHead,
		recordsAfterPagingAndSorting,
		TblPagination
	} = useTable(records, headCells, filterFn);

	const salir = () => {
		props.onHideCancela();
	};

	const aceptar = () => {
		var sigue = true;
		if (txtFechaApro.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir la Fecha de aprobación.', icono: 'informacion' });
			sigue = false;
			txtFechaApro.current.focus();
		} else if (txtNumContrato.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Número de Contrato de la Obra.', icono: 'informacion' });
			sigue = false;
			txtNumContrato.current.focus();
		} else if (txtPlazoIni.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Plazo de Inicio de la Obra.', icono: 'informacion' });
			sigue = false;
			txtPlazoIni.current.focus();
		} else if (txtPlazoEjec.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Plazo de Ejecución de la Obra.', icono: 'informacion' });
			sigue = false;
			txtPlazoEjec.current.focus();
		} else if (txtGarantia.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Lapso de Garantia de la Obra.', icono: 'informacion' });
			sigue = false;
			txtGarantia.current.focus();
		} else if (txtManera.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el La Manera de Pago de la Obra.', icono: 'informacion' });
			sigue = false;
			txtManera.current.focus();
		}
		if (sigue) {
			let body = {
				idobraasignada: txtIdObraAsi.current.value,
				plazoini: txtPlazoIni.current.value.toUpperCase(),
				plazoejec: txtPlazoEjec.current.value.toUpperCase(),
				garantia: txtGarantia.current.value.toUpperCase(),
				porcefiel: txtPorceFiel.current.value.replace(/\./g, "").replace(",", "."),
				porcenti: txtPorceAnti.current.value.replace(/\./g, "").replace(",", "."),
				numcomtrato: txtNumContrato.current.value.toUpperCase(),
				condicion: radioSi.current.checked ? "1" : "0",
				fecha: txtFechaApro.current.value,
				manera: txtManera.current.value.toUpperCase(),
				siniva: checkIva.current.checked ? "1" : "0",
			};
			//alert(JSON.stringify(body))
			actualizarCaratulaContrato(body);
		}

	};

	const actualizarCaratulaContrato = (body) => {
		setActivate(true);
		let endpoint = `${op.conexion}/api/ingenieria/actualizarcaratulacontrato`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status == 200) {
					if (response.data) {
						setActivate(false);
						//setDesde(1);
						setMensaje({
							mostrar: true,
							titulo: "Exito.",
							texto: "El registro " + response.data.rows[0].caratula_act + " fué actualizado.",
							icono: "informacion",
						});
						/*if (props.operacion === 1) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido asignada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 2) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido modificada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 3) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido ha sido Eliminada de manera satisfactoria.",
								icono: "informacion",
							});
						}*/

					}
				}
			})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const cerrarModal = () => {
		setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
		props.onHideCancela();
	};

	const seleccionarProveedor = (id) => {
		let campos = "*";
		let nomtab = "proveedor";
		let nomid = "idproveedor";

		let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
		setActivate(true);

		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status == 200) {
					if (response.data !== "") {
						//txtIdProve.current.value = response.data.idproveedor;
						txtRazonSocial.current.value = response.data.razonsocial;
						txtRif.current.value = response.data.rif;
					} else {
						txtIdProve.current.value = "";
						setMensaje({
							mostrar: true,
							titulo: "Notificación",
							texto: "No existe una Proveedor con este Codigo.",
							icono: "informacion",
						});
					}
				}
				setActivate(false);
			})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});

				setActivate(false);
			});
	};

	const handleInputMontoChange = (event) => {
		validaMonto(event);
		if (event.target.value === "" || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.0) {
			event.target.value = "0,00";
		}

		if (event.which >= 37 && event.which <= 40) {
			event.preventDefault();
		}
		if (event.which === 13 || typeof event.which === "undefined") {
			event.target.value = formatoMonto(event.target.value);
			let char1 = event.target.value.substring(0, 1);
			let char2 = event.target.value.substring(1, 2);
			if (char1 === "0" && char2 !== ",") {
				event.target.value = event.target.value.substring(1, event.target.value.legth);
			}
			let monto;
			if (event.target.id === "porcefiel") {
				monto = parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) * parseFloat(txtMontoObra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
				txtMontoFiel.current.value = formatMoneda(monto.toString().replace(".", ","), ",", ".", 2);
				if (event.which === 13) {
					txtPorceAnti.current.focus();
				}
			} else if (event.target.id === "porceanti") {
				let monto = parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) * parseFloat(txtMontoObra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
				txtMontoAnti.current.value = formatMoneda(monto.toString().replace(".", ","), ",", ".", 2);
				if (event.which === 13) {
					txtManera.current.focus();
				}
			}
		} else if (event.which === 46) {
			return false;
		} else if (event.which >= 48 && event.which <= 57) {
			return true;
		} else if (event.which === 8 || event.which === 0 || event.which === 44) {
			return true;
		} else return false;
	};

	const imprimirContrato = () => {
		var sigue = true;
		if (txtFechaApro.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere la Fecha de aprobación.', icono: 'informacion' });
			sigue = false;
			txtFechaApro.current.focus();
		} else if (txtNumContrato.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere el Número de Contrato de la Obra.', icono: 'informacion' });
			sigue = false;
			txtNumContrato.current.focus();
		} else if (txtPlazoIni.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere el Plazo de Inicio de la Obra.', icono: 'informacion' });
			sigue = false;
			txtPlazoIni.current.focus();
		} else if (txtPlazoEjec.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere el Plazo de Ejecución de la Obra.', icono: 'informacion' });
			sigue = false;
			txtPlazoEjec.current.focus();
		} else if (txtGarantia.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere el Lapso de Garantia de la Obra.', icono: 'informacion' });
			sigue = false;
			txtGarantia.current.focus();
		} else if (txtManera.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere la manera en que sera distribuido el pago.', icono: 'informacion' });
			sigue = false;
			txtManera.current.focus();
		}
		if (sigue) {
			let reporte = "ForCaratula_Contrato";
			if (radioServicio.current.checked){
				reporte = "ForCaratula_Contrato_Ser";
			}
			let monto = txtMontoObra.current.value;
			let sql3 = numeroaLetra(monto.trim().replace(/\./g, "")) + " Bs.";
			let sql ="obra.idobra ="+props.obra.idobra;
			let sql1 = txtMontoFiel.current.value; 
			let sql2 = txtMontoAnti.current.value; 
			let idorg = JSON.parse(localStorage.getItem("idorganizacion"));
			window.open(
				op.reportes +
				"/ingenieria?" +
				"reporte=" +
				reporte +
				"&MONTOFIEL=" +
				sql1 +
				"&MONTOGAR=" +
				sql2 +
				"&MONTOOBRA=" +
				monto +
				"&CONDICION=" +
				sql +
				"&ORGANIZACION=" +
				idorg +
				"&ENLETRAS=" +
				sql3 +
				"&DISTRIBUIDO=" +
				txtGarantia.current.value,
				"Planilla",
				"fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
			);
		}
	}

	return (
		<Modal
			size="lg"
			{...props}
			centered backdrop="static"
			keyboard={false}
			onShow={() => {
				txtIdObraAsi.current.value = props.obra.idobraasignada;
				txtMontoObra.current.value = formatMoneda(props.obra.monto.toString().replace('.', ','), ',', '.', 2)
				//txtDescripcionObra.current.value = props.obra.descripcionobra;
				txtDescripcionObra.current.value = props.cuentas[0].tipoobra === 2 ? props.cuentas[0].descripcion.trim() : props.cuentas[0].descripcionobra.trim();
				txtFechaApro.current.value = props.cuentas[0].fecapro === null ? moment.utc(fechasistema).format("YYYY-MM-DD") : moment.utc(props.cuentas[0].fecapro).format("YYYY-MM-DD");
				txtNumContrato.current.value = props.cuentas[0].numcontrato === null ? "" : props.cuentas[0].numcontrato;
				txtPorceFiel.current.value = props.cuentas[0].porcfiel === null ? "0,00" : formatMoneda(props.cuentas[0].porcfiel.toString().replace('.', ','), ',', '.', 2);
				txtPorceAnti.current.value = props.cuentas[0].porantic === null ? "0,00" : formatMoneda(props.cuentas[0].porantic.toString().replace('.', ','), ',', '.', 2);
				var monant = parseFloat(0.00);
				if (props.cuentas[0].porantic !== null && parseFloat(props.obra.monto) > 0 && parseFloat(props.cuentas[0].porantic) > 0) {
					monant = parseFloat(props.obra.monto) * parseFloat(props.cuentas[0].porantic) / 100;
					monant = Math.round(monant * Math.pow(10, 2)) / Math.pow(10, 2);
				}
				txtMontoAnti.current.value = formatMoneda(monant.toString().replace('.', ','), ',', '.', 2);
				var monfiel = parseFloat(0.00);
				if (props.cuentas[0].porcfiel !== null && parseFloat(props.obra.monto) > 0 && parseFloat(props.cuentas[0].porcfiel) > 0) {
					monfiel = parseFloat(props.obra.monto) * parseFloat(props.cuentas[0].porcfiel) / 100;
					monfiel = Math.round(monfiel * Math.pow(10, 2)) / Math.pow(10, 2);
				}
				txtMontoFiel.current.value = formatMoneda(monfiel.toString().replace('.', ','), ',', '.', 2);
				if (props.cuentas[0].tipoobra === 1) {
					radioObra.current.checked = true;
					radioServicio.current.checked = false;
				} else {
					radioObra.current.checked = false;
					radioServicio.current.checked = true;
				}
				if (props.cuentas[0].condicion === "0") {
					radioNo.current.checked = true;
					radioSi.current.checked = false;
				} else {
					radioNo.current.checked = false;
					radioSi.current.checked = true;
				}
				txtPlazoIni.current.value = props.cuentas[0].plazoini === null ? "" : props.cuentas[0].plazoini;
				txtPlazoEjec.current.value = props.cuentas[0].plazoejec === null ? "" : props.cuentas[0].plazoejec;
				txtGarantia.current.value = props.cuentas[0].lapsogar === null ? "" : props.cuentas[0].lapsogar;
				txtManera.current.value = props.cuentas[0].manera === null ? "" : props.cuentas[0].manera;
				setRecords(props.cuentas);
				seleccionarProveedor(props.obra.idproveedor);
			}}>
			<Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
				<h3 className="fw-bold m-0">Caratula del Contrato</h3>
				<a type="button" className="fw-bold text-light fs-6" onClick={salir}>
					Salir <i className="fa fa-times ms-2"></i>
				</a>
			</Modal.Header>
			<Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap d-flex" style={{ height: 500, overflowY: 'auto' }}>
				<div className="col-3 m-0 mb-2 p-0">
					<Input label="Código:" readOnly ref={txtIdObraAsi} />
				</div>
				<div className="col-4 m-0 mb-2 ml-auto p-0 pl-2">
					<Input label='Fecha de Aprobación:' type='date' ref={txtFechaApro} disabled={props.deshabilitado} />
				</div>
				<div className="col-3 m-0 mb-2 p-0 pl-2">
					<Input label='Nº del Contrato:' ref={txtNumContrato} disabled={props.deshabilitado} />
				</div>
				<div className="col-12 m-0 p-0 d-flex gap-4">
					<div className="col-auto m-0 p-0 d-flex gap-2">
						<span className="fw-bold">Contrato con Condiciones Especiales:</span>
						<div className="col-auto m-0 p-0">
							<Radio label="Sí" name="radioCondicion" id="si" ref={radioSi} disabled={props.deshabilitado} />
						</div>
						<div className="col-auto m-0 p-0">
							<Radio label="No" name="radioCondicion" id="no" ref={radioNo} disabled={props.deshabilitado} />
						</div>
					</div>
					<div className="col-auto m-0 p-0 d-flex gap-2">
						<span className="fw-bold">Tipo:</span>
						<div className="col-auto m-0 p-0">
							<Radio label="Obra" name="tipo" id="tipo1" ref={radioObra} disabled={props.deshabilitado} />
						</div>
						<div className="col-auto m-0 p-0">
							<Radio label="Servicio" name="tipo" id="tipo2" ref={radioServicio} disabled={props.deshabilitado} />
						</div>
					</div>
				</div>
				<div className="col-12 m-0 p-0">
					<TblContainer>
						<TblHead />
						<tbody>
							{records &&
								recordsAfterPagingAndSorting().map((item, index) => (
									item.proyecto === '' ? '' :
										<tr key={index} style={{ padding: "0" }}>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(0, 2)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(2, 4)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(4, 6)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(6, 8)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.categoria.substring(8, 10)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(0, 3)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(3, 5)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(5, 7)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.puc.substring(7, 9)}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.auxiliar}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{item.descripcion}
											</td>
											<td
												className="align-baseline"
												style={{ textAlign: "center", alignItems: "center" }}
											>
												{formatMoneda(parseFloat(item.montoobra).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
											</td>

										</tr>
								))}
						</tbody>
					</TblContainer>
				</div>
				<div className="col-8 m-0 p-0">
					<Textarea label="Descripción:" style={{ height: 70 }} readOnly ref={txtDescripcionObra} />
				</div>
				<div className="col-4 m-0 p-0 pl-2">
					<Input label='Monto de la Obra:' readOnly ref={txtMontoObra} inputClassName="text-right" />
				</div>
				<fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap border-azul rounded">
					<legend className="float-none w-auto m-0">
						Datos del Contratista
					</legend>
					<div className="col-8 m-0 p-0">
						<Input label='Nombre o Razón Social:' readOnly ref={txtRazonSocial} />
					</div>
					<div className="col-4 m-0 p-0 pl-2">
						<Input label='RIF:' readOnly ref={txtRif} />
					</div>
				</fieldset>
				<div className="col-12 m-0 mb-2 p-0">
					<Textarea label="Plazo para el comienzo de la Obra:" style={{ height: 70 }} ref={txtPlazoIni} disabled={props.deshabilitado} />
				</div>
				<div className="col-12 m-0 mb-2 p-0">
					<Textarea label="Plazo de Ejecución de la Obra:" style={{ height: 70 }} ref={txtPlazoEjec} disabled={props.deshabilitado} />
				</div>
				<div className="col-12 m-0 mb-2 p-0">
					<Textarea label="Lapso de Conservación o Garantía:" style={{ height: 70 }} ref={txtGarantia} disabled={props.deshabilitado} />
				</div>
				<div className="col-4 m-0 mb-2 p-0">
					<Input label='Garantia Fiel Cumplimiento %:' id="porcefiel" inputClassName="text-right" ref={txtPorceFiel} disabled={props.deshabilitado} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
				</div>
				<div className="col-3 m-0 mb-2 p-0 pl-2">
					<Input label='Anticipo %:' id="porceanti" inputClassName="text-right" ref={txtPorceAnti} disabled={props.deshabilitado} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
				</div>
				<div className="col-4 m-0 mb-2 ml-auto p-0 pl-2">
					<Checkbox label='No Incluir Monto de Iva' ref={checkIva} disabled={props.deshabilitado} />
				</div>
				<div className="col-6 m-0 mb-2 p-0">
					<Input label='Monto Garantia Fiel Cumplimiento:' inputClassName='text-end' placeholder='0.00' readOnly ref={txtMontoFiel} />
				</div>
				<div className="col-6 m-0 mb-2 p-0">
					<Input label='Monto Anticipo:' inputClassName='text-end' placeholder='0.00' readOnly ref={txtMontoAnti} />
				</div>
				<div className="col-12 m-0 p-0">
					<Textarea label='Pagado de la siguiente manera:' style={{ height: 70 }} ref={txtManera} disabled={props.deshabilitado} />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<SuccessButton ref={btnAcepta} onClick={aceptar}>
					Aceptar
				</SuccessButton>
				<DangerButton ref={btnCancela} onClick={salir}>
					Cancelar
				</DangerButton>
				<InfoButton icon='fa-print'
					disabled={!props.deshabilitado}
					onClick={imprimirContrato}
					ref={btnImprimir}
				>
					Imprimir
				</InfoButton>
			</Modal.Footer>
			<Dimmer active={activate} inverted>
			</Dimmer>
			<Mensaje
				mensaje={mensaje}
				onHide={() => {
					mensaje.titulo === "Exito."
						? cerrarModal()
						: setMensaje({
							mostrar: false,
							titulo: "",
							texto: "",
							icono: "",
						});
				}}
			/>
		</Modal>
	);
}